import React, { Fragment } from 'react'
import Carousal from './Carousal'
import Section from './Section'
import Review from './Review'
import Freaquent from './Freaquent'
import Contact from './Contact'
import Footer from './Footer'
import Videos from './Videos'


const Home = () => {
  return (
    <div>
      <Carousal />
      <Section />
      <Review/>
      <Videos/>
     <Freaquent/>
     <Contact/>
     <Footer/>

    </div>
  )
}

export default Home